/**
 * "Fly to cart" micro-interaction: a small clone of the product image arcs
 * from the clicked card into the header cart icon. Pure DOM + WAAPI so it
 * needs no React state; respects prefers-reduced-motion.
 */
export function flyToCart(sourceEl: HTMLElement | null, imageUrl?: string): void {
  if (!sourceEl) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  // Two cart buttons exist (desktop + mobile nav) — target the visible one.
  const targets = Array.from(
    document.querySelectorAll<HTMLElement>('[data-cart-target]'),
  ).filter((el) => el.getBoundingClientRect().width > 0);
  const target = targets[0];
  if (!target) return;

  const from = sourceEl.getBoundingClientRect();
  const to = target.getBoundingClientRect();

  const size = 44;
  const ghost = document.createElement(imageUrl ? "img" : "div");
  if (imageUrl) {
    (ghost as HTMLImageElement).src = imageUrl;
    ghost.style.objectFit = "cover";
  } else {
    ghost.style.background = "hsl(var(--primary))";
  }
  Object.assign(ghost.style, {
    position: "fixed",
    left: `${from.left + from.width / 2 - size / 2}px`,
    top: `${from.top + from.height / 2 - size / 2}px`,
    width: `${size}px`,
    height: `${size}px`,
    borderRadius: "12px",
    zIndex: "9999",
    pointerEvents: "none",
    boxShadow: "0 8px 24px rgba(0,0,0,.35)",
  });
  document.body.appendChild(ghost);

  const dx = to.left + to.width / 2 - (from.left + from.width / 2);
  const dy = to.top + to.height / 2 - (from.top + from.height / 2);

  const animation = ghost.animate(
    [
      { transform: "translate(0, 0) scale(1)", opacity: 1 },
      // Slight lift before diving toward the cart gives the arc feel.
      { transform: `translate(${dx * 0.4}px, ${dy * 0.4 - 40}px) scale(0.7)`, opacity: 0.95, offset: 0.55 },
      { transform: `translate(${dx}px, ${dy}px) scale(0.15)`, opacity: 0.4 },
    ],
    { duration: 650, easing: "cubic-bezier(.3,.7,.4,1)" },
  );
  animation.onfinish = () => ghost.remove();
  animation.oncancel = () => ghost.remove();
}
